import styled from 'styled-components';
import { gray10, gray95, spacer12, spacer24 } from '@spotify-internal/encore-foundation';
import { typeStyleBody2, typeStyleBody3, cursorDisabled } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.formCheckbox === 'dark';
};

var isSmall = function isSmall(props) {
  return props.small === true;
};

export default styled.span.withConfig({
  displayName: "Label",
  componentId: "msbr92-0"
})(["color:", ";", ";padding-left:", ";padding-right:", ";input:disabled ~ &{cursor:", ";opacity:0.5;}"], function (props) {
  return isDarkTheme(props) ? gray95 : gray10;
}, function (props) {
  return isSmall(props) ? typeStyleBody3() : typeStyleBody2();
}, spacer12, spacer24, cursorDisabled);